import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {SortingState,IntegratedSorting,PagingState,IntegratedPaging,SearchState,IntegratedFiltering} from '@devexpress/dx-react-grid';
import {Grid,Table,TableHeaderRow,SearchPanel,Toolbar,TableColumnReordering,DragDropProvider,TableColumnVisibility,ColumnChooser} from '@devexpress/dx-react-grid-bootstrap4';
import {PagingPanel} from '@devexpress/dx-react-grid-material-ui';
import '../../theme/styles/dx-react-grid-bootstrap4.css';
import '../../theme/styles/reactstrap.css';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
var styles=require('./Report.less');
import {DropdownButton, MenuItem, Button} from 'react-bootstrap';
import * as reportActions from './../../actions/reportActions';
 import moment from 'moment';
import '../../theme/styles/styles.css';
import '../../theme/styles/bootstraptable.css';
import * as instrumentListActions from './../../actions/instrumentListActions';
import * as commonActions from './../../actions/commonActions';
import {getPath} from './../../actions/commonActions';
import config from './../../config.js';
import {DcoDropdown} from './../../components/UI/Dropdown/Dropdown';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import '../../theme/styles/mediaqueries.css';
import Modal from 'react-modal';
import * as filesaver from './../../actions/FileSaver';
import i18next from 'i18next';
import momenttz from 'moment-timezone';
import ReactExport from "react-data-export";
import numeral  from 'numeral';
import DateSelector from './../DateSelector/DateSelector';
import {getSelectedDate,getCountofTableRows} from './../../utils/utils'; //import
import { applyStyle,applyToHover,setDirection } from './../../utils/utils';
import { withStyles } from '@material-ui/core/styles';
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const elementsData = [
  {"classNames":"fltrBarInner", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"reportsDropdown", "elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"dropdown-toggle", "elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"caret","elementType":"normal", "applyTo":"all", "tagNames":"span"},
  {"classNames":"dropdown-menu","elementType":"normal", "applyTo":"all", "tagNames":"ul"},
  {"classNames":"dropDownList","elementType":"tag", "applyTo":"all", "tagNames":"a"},
  {"classNames":"glyphicon","elementType":"normal", "applyTo":"all", "tagNames":"span"},
  {"classNames":"material-icons","elementType":"normal", "applyTo":"all", "tagNames":"i"},
  {"classNames":"mdlWrap","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"dx-g-bs4-table","elementType":"normal", "applyTo":"all", "tagNames":"table"},
  {"classNames":"subTrdTbl","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"reportsTblGrid","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"form-control","elementType":"normal", "applyTo":"all", "tagNames":"input"},
  {"classNames":"oi-eye","elementType":"normal", "applyTo":"all", "tagNames":"span"},
  {"classNames":"dx-g-bs4-table","elementType":"normal", "applyTo":"all", "tagNames":"table"},
  {"classNames":"dx-g-bs4-header-cell","elementType":"tag", "applyTo":"all", "tagNames":"th"},
  {"classNames":"dx-g-bs4-table-cell","elementType":"tag", "applyTo":"all", "tagNames":"td"},
  {"classNames":"flex-column","elementType":"normal", "applyTo":"all", "tagNames":"div","parent":"reportsTblGrid"},
  {"classNames":"noDataCell","elementType":"tag", "applyTo":"all", "tagNames":"td"},
  {"classNames":"closeBtn","elementType":"normal", "applyTo":"single", "tagNames":"div"},
];
const directionData=[
  {"classNames":"commonGoBtn", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"card-header", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"btnText","elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"dropdown-menu","elementType":"normal", "applyTo":"all", "tagNames":"ul"},
  {"classNames":"reportsTblGrid","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"allExportFilter","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"subTrdDrpdown","elementType":"normal", "applyTo":"all", "tagNames":"div"}
];
let socketDataStatic=[];
let fileName = "Rpt_TrdReg_Deal";
let compareRate = (a, b) => {
  let result;
    if (numeral(a)._value < numeral(b)._value) {
      result = -1;
    }else{
      result = 1;
    }
    return result;
};
const orderCols = ["docno","docdate","deal_type","inst_desc","pcs_qty","ord_stk_code","price","VT","ord_status","deal_doc_no","remarks"]
const ordersOutCols = ["docno","docdate","deal_type","inst_desc","pcs_qty","ord_stk_code","price","VT","remarks"]
const orderFillCols = ["docno","docdate","deal_type","inst_desc","pcs_qty","ord_stk_code","price","VT","ord_status","deal_doc_no","remarks"]

const fixingOutCols = ["docno","docdate","fixingEvent","deal_type","inst_desc","pcs_qty","ord_stk_code","remarks"]
const fixingFillCols = ["docno","fixingEvent","deal_type","inst_desc","filledTime","pcs_qty","ord_stk_code","price","deal_doc_no","remarks"]
const fixingCancelledCols = ["docno","fixingEvent","deal_type","inst_desc","cancelledTime","pcs_qty","ord_stk_code","remarks"]

@connect(state => ({clickedEdit: state.dashboardRoot.dashboardReducer.clickedEdit,
    SubTrdRegisterData: state.dashboardRoot.reportReducer.SubTrdRegisterData,
    reportData: state.dashboardRoot.reportReducer.reportData,
    reportPageSize: state.dashboardRoot.reportReducer.reportPageSize,
    socketDataStatic: state.dashboardRoot.instrumentListReducer.socketDataStatic,
    trdPanelData: state.dashboardRoot.instrumentListReducer.trdPanelData,
    defAcc: state.dashboardRoot.dashboardReducer.defAcc,
    clearField:state.dashboardRoot.reportReducer.clearField,
    ACD: state.auth.ACD,
    DFA: state.auth.DFA,
    DCO:state.dashboardRoot.instrumentListReducer.DCO,
    userDetail: state.auth.userDetail,
    openCalender: state.dashboardRoot.commonReducer.openCalender,
    selectedCssColorTheme:state.dashboardRoot.commonReducer.selectedCssColorTheme,
    selectedCssColor:state.dashboardRoot.commonReducer.selectedCssColor,
    selectedLang:state.dashboardRoot.commonReducer.selectedLang,
    language:state.dashboardRoot.commonReducer.language,
    fixingEvents:state.dashboardRoot.dashboardReducer.fixingEvents,
}), {
  ...reportActions,
  ...instrumentListActions,
  ...commonActions
})

export default class ReportComponent extends Component {
  static propTypes = {
    showPreview: PropTypes.object,
    reportPageSize: PropTypes.string,
    getExportedReport: PropTypes.func,
    SubTrdRegisterData: PropTypes.object,
    loadAlldealReport: PropTypes.func,
    socketDataStatic: PropTypes.array,
    trdPanelData: PropTypes.object,
    getInvoice: PropTypes.func,
    ACD: PropTypes.object,
    DFA: PropTypes.object,
    userDetail:PropTypes.object,
    onClickCalender:PropTypes.func,
    openCalender:PropTypes.boolean,
  }
  constructor(props) {
    super(props);
    this.state = {
      subTrdRegisterCmdty: 'allPairs',
      subTrdRegisterCmdtyKey:'ALL',
      DCO:[],
      CmdtyPairdata: [],
      showRptDialog: false,
      currentDate: new Date().toLocaleDateString('en-US'),
      startDate: new Date().toLocaleDateString('en-US'),
      endDate: new Date().toLocaleDateString('en-US'),
      loadtableflag: true,
      isClearTradeReg: false,
      isRefreshDisabled:  true,
      ranges: {
        [i18next.t('today')]: [
          moment(), moment()
        ],
        [i18next.t('yesterday')]: [
          moment().subtract(1, 'days'),
          moment().subtract(1, 'days')
        ],
        [i18next.t('last7Days')]: [
          moment().subtract(6, 'days'),
          moment()
        ],
        [i18next.t('last30Days')]: [
          moment().subtract(29, 'days'),
          moment()
        ],
        [i18next.t('thisMonth')]: [
          moment().startOf('month'), moment().endOf('month')
        ],
        [i18next.t('lastMonth')]: [
          moment().subtract(1, 'month').startOf('month'),
          moment().subtract(1, 'month').endOf('month')
        ]
      },
     SubTrdRegisterData:this.props.SubTrdRegisterData,
     subTrdRegColumnOrder:['user_code','docno','docdate','valdate','deal_type','inst_desc','pcs_qty','grs_qty','mtl_rate','amt','evt_ts','remarks'],
     HiddenSubTrdOrderCol:[],
     HiddenSubTrdDealCol:[],
     HiddenSubTrdOutCol:[],
     HiddenSubTrdFillCol:[],
     pageSizes: [10, 15, 20, 0],
     searchValue:'',
     tradeType:'trades',
     tradeTypeKey:'D',
     qty_type: 'OZ',
     qty_types: true,
     subTrdRegOrderType: '',
     subTrdRegOrderTypeKey:'',
     actionType:'',
     tradeTypeAction:'D',
     qtyTypeColName:'',
     qtyTypeSelected:'OZ',
     COM:null,
     integratedSortingColumnExtensions: [
         { columnName: 'pcs_qty',compare: compareRate, align:'right' },
         { columnName: 'grs_qty',compare: compareRate, align:'right' },
         { columnName: 'mtl_rate',compare: compareRate, align:'right' },
         { columnName: 'amt',compare: compareRate, align:'right' },
         { columnName: 'price',compare: compareRate, align:'right'}
       ],
     id:'today',
     validationFlag:false,
     keyValue:'tradeRegister',
     reportsRowsCount:0,
     SubTrdOrderCols: [],
     SubTrdDealCols:["docno","docdate","valdate","deal_type","inst_desc","grs_qty","mtl_rate","amt","evt_ts","remarks"],
     SubTrdOutstandingCols: [],
     SubTrdFillOrderCols: [],
     selectedFixingCode: undefined,
     selectedFixingEvent : ''
    }
    this.onChangeSearchValue = this.onChangeSearchValue.bind(this);
    this.onChangeSubTrdRegColumnOrder = this.onChangeSubTrdRegColumnOrder.bind(this);
    this.onChangeHiddenSubTrdOrderCol = this.onChangeHiddenSubTrdOrderCol.bind(this);
    this.onChangeHiddenSubTrdDealCol = this.onChangeHiddenSubTrdDealCol.bind(this);
    this.onChangeHiddenSubTrdFillCol = this.onChangeHiddenSubTrdFillCol.bind(this);
    this.onChangeHiddenSubTrdOutCol = this.onChangeHiddenSubTrdOutCol.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
  }

  componentDidMount() {
    const thisComponent = ReactDOM.findDOMNode(this);
    //const allCssStyleRules = this.props.selectedCssColorTheme;
    //applyStyle(thisComponent, allCssStyleRules, elementsData);
    setDirection(ReactDOM.findDOMNode(this),directionData,this.props.selectedLang);
    const hoverElementsClassNames = [
        {"elmToHover":thisComponent.getElementsByClassName("closeBtn")[0], "classNames":"closeBtn"},
        {"elmToHover":thisComponent.getElementsByClassName("button-l")[0], "classNames":"button-l"},
    ];
    ////applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
      this.setOrdersDetails();
      socketDataStatic = this.props.socketDataStatic;
      this.setState({subTrdRegOrderType:''});
      this.setState({subTrdRegOrderTypeKey:'O'});
      this.setState({ qtyTypeColName: i18next.t('quantity') +'('+this.state.qtyTypeSelected+')' });
      this.setState({COM: null});
  }

  componentWillMount() {
      const locale = locale;
      this.setState({locale: { 'format': 'DD-MM-YYYY' },});
  }

  componentDidUpdate(preProps){
    const thisComponent = ReactDOM.findDOMNode(this);
    //const allCssStyleRules = this.props.selectedCssColorTheme;
    //applyStyle(thisComponent, allCssStyleRules, elementsData);
  }

  subTrdRegOrderType = (text,value) => {
    try {
      this.setState({ subTrdRegOrderType: text });
      this.setState({ subTrdRegOrderTypeKey: value });
      this.setState({ actionType: value });
      this.setState({ loadtableflag: true });
      if (this.state.tradeTypeKey === 'D') {
        this.props.loadTradeRegReport(moment(this.state.startDate).format('DD-MM-YYYY'), moment(this.state.endDate).format('DD-MM-YYYY'), this.state.subTrdRegisterCmdtyKey, this.state.qty_type, this.state.tradeTypeKey, value);
      }
      else {
        // for outstanding order set start and end date as today
        this.props.loadTradeRegReport(
          moment(value === 'O' ? new Date() : this.state.startDate).format('DD-MM-YYYY'),
          moment(value === 'O' ? new Date() : this.state.endDate).format('DD-MM-YYYY'),
          this.state.subTrdRegisterCmdtyKey, '', this.state.tradeTypeKey, value, this.state.selectedFixingCode
        );
      }
    } catch (e) {
      this.props.logFileCreation({ error: e.message, originFunction: 'subTrdRegOrderType', component: "TradeRegister" });
    }
}

  closeRptModal = (event) => {
    try{
      this.setState({showRptDialog: false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeRptModal', component:"TradeRegister"});
    }
  }

  handleEvent = (event,picker) => {
    try{
      this.setState({startDate: picker.startDate.format('DD-MM-YYYY'), endDate: picker.endDate.format('DD-MM-YYYY')});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'handleEvent', component:"TradeRegister"});
    }
  }

  getDecimal=(CmdtyPair)=>{
    try{
      var dec;
      for (let index = 0; index <this.state.socketDataStatic.length; index++) {
        if (this.state.socketDataStatic[index].ID === CmdtyPair) {
          dec = this.state.socketDataStatic[index].dec;
          break;
        }
      }
      return dec;
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'getDecimal', component:"TradeRegister"});
    }
  }

  getSubTrdReg=()=>{
    try{
      this.setState({ loadtableflag: true });
      if(this.state.tradeTypeKey == 'D'){
        this.setState({actionType:''});
      }else{
        this.setState({ actionType: this.state.subTrdRegOrderTypeKey });
      }
      // if(this.state.subTrdRegisterCmdtyKey == 'ALL'){
      //   this.setState({ qtyTypeSelected: 'OZ'});
      //   this.setState({qty_types: true});
      // }
      if (this.state.COM === 1) {
        this.setState({ qtyTypeColName: i18next.t('quantity')});
      }
      else {
        this.setState({ qtyTypeColName: i18next.t('quantity')+"("+this.state.qtyTypeSelected+")" });
      }
      this.setState({ tradeTypeAction: this.state.tradeTypeKey });
      this.setState({ isRefreshDisabled : true });
      if (this.state.tradeTypeKey === 'D') {
        this.props.loadTradeRegReport(moment(this.state.startDate).format('DD-MM-YYYY'),moment(this.state.endDate).format('DD-MM-YYYY'),this.state.subTrdRegisterCmdtyKey, this.state.qty_type, this.state.tradeTypeKey, this.state.subTrdRegOrderTypeKey);
      }
      else {
        this.props.loadTradeRegReport(moment(this.state.startDate).format('DD-MM-YYYY'),moment(this.state.endDate).format('DD-MM-YYYY'),this.state.subTrdRegisterCmdtyKey, '', this.state.tradeTypeKey, this.state.subTrdRegOrderTypeKey, this.state.selectedFixingCode);
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'getSubTrdReg', component:"TradeRegister"});
    }
  }

  componentWillReceiveProps(nextProps){
    const thisComponent = ReactDOM.findDOMNode(this);
    //const allCssStyleRules = this.props.selectedCssColorTheme;
    //applyStyle(thisComponent, allCssStyleRules, elementsData);
    setDirection(ReactDOM.findDOMNode(this),directionData,nextProps.selectedLang);
    // if(this.props.selectedCssColorTheme !== nextProps.selectedCssColorTheme){
    //   const thisComponent = ReactDOM.findDOMNode(this);
    //   const allCssStyleRules = nextProps.selectedCssColorTheme;
    //   applyStyle(thisComponent, allCssStyleRules, elementsData);
    // };
    if (this.props.selectedLang !== nextProps.selectedLang) {
      const thisComponent = ReactDOM.findDOMNode(this);
      setDirection(ReactDOM.findDOMNode(this),directionData,nextProps.selectedLang);
    }
    if(this.state.isClearTradeReg !== this.props.isClearTradeReg){
      this.setState({ isClearTradeReg: true });
      this.setState({ loadtableflag: true });
      this.setState({ isRefreshDisabled : true });
      this.setState({startDate: new Date().toLocaleDateString('en-US')});
      this.setState({endDate:new Date().toLocaleDateString('en-US')});
      this.setState({currentDate: new Date().toLocaleDateString('en-US')});
      this.setState({id:'today'});
      this.setState({ subTrdRegisterCmdty: 'allPairs' });
      this.setState({ subTrdRegisterCmdtyKey:'ALL'});
    }
    if(nextProps.SubTrdRegisterData !== this.props.SubTrdRegisterData){
      this.setState({ loadtableflag: false });
      this.setState({ isRefreshDisabled : false });
      this.setState({ reportsRowsCount : nextProps.SubTrdRegisterData.length });
    }
  }
  setStartDate = startDate => {
    try{
      this.setState({ startDate:startDate});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'setStartDate', component:"TradeRegister"});
    }
  }

  setEndDate = endDate => {
    try{
      this.setState({ endDate:endDate });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'setEndDate', component:"TradeRegister"});
    }
  }

  closeValidationModal=()=>{
    try{
      this.setState({validationFlag :false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeValidationModal', component:"TradeRegister"});
    }
  }

  changeQty_type = (qnt_type, value) => {
    try{
      this.setState({qty_type: qnt_type});
      this.setState({qtyTypeSelected: value});
      this.setState({ loadtableflag: true });
        if (this.state.COM === 1) {
          this.setState({ qtyTypeColName: i18next.t('quantity')});
        }
        else {
          this.setState({ qtyTypeColName: i18next.t('quantity')+"("+value+")" });
        }
        if (this.state.tradeTypeKey === 'D') {
          this.props.loadTradeRegReport(moment(this.state.startDate).format('DD-MM-YYYY'),moment(this.state.endDate).format('DD-MM-YYYY'),this.state.subTrdRegisterCmdtyKey,qnt_type, this.state.tradeTypeKey, this.state.subTrdRegOrderTypeKey);
        }
        else {
          this.props.loadTradeRegReport(moment(this.state.startDate).format('DD-MM-YYYY'),moment(this.state.endDate).format('DD-MM-YYYY'),this.state.subTrdRegisterCmdtyKey, '', this.state.tradeTypeKey, this.state.subTrdRegOrderTypeKey);
        }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'changeQty_type', component:"TradeRegister"});
    }
  }

  onChangeSubTrdRegisterCmdty = (filterValue,filterText) => {
    try{
      this.setState({subTrdRegisterCmdty: filterText});
      this.setState({subTrdRegisterCmdtyKey:filterValue});
      if(filterValue == 'ALL'){
        this.setState({COM:null});
      }else{
      let index1;
      for (let index = 0; index < this.props.socketDataStatic.length; index++) {
        const cmdty = this.props.socketDataStatic[index].I;
        const cmdtyDes = this.props.socketDataStatic[index].ID;
        if (filterValue === cmdty) {
            index1=index;
        }
      }
      this.setState({COM:parseInt((this.props.socketDataStatic[index1]).B)});
      const T1=this.props.socketDataStatic[index1].T1;
      const unit = [];
      const lengthTrdData = this.props.trdPanelData.length;
      for (let index = 0; index < lengthTrdData; index++) {
        const stk_type = this.props.trdPanelData[index].stk_type;
        if (stk_type === T1) {
          unit.push(this.props.trdPanelData[index].C);
        }
      }
      //this.setState({qty_type: unit[0]});
      if (this.state.tradeTypeKey === 'D') {
        this.setState({qty_types: true});
      }
      else {
        this.setState({qty_types: false});
      }
      }
      this.setState({ loadtableflag: true });
      if (this.state.tradeTypeKey === 'D') {
        this.props.loadTradeRegReport(moment(this.state.startDate).format('DD-MM-YYYY'),moment(this.state.endDate).format('DD-MM-YYYY'),filterValue, this.state.qty_type, this.state.tradeTypeKey, this.state.subTrdRegOrderTypeKey);
      }
      else {
        this.props.loadTradeRegReport(moment(this.state.startDate).format('DD-MM-YYYY'),moment(this.state.endDate).format('DD-MM-YYYY'),filterValue, '', this.state.tradeTypeKey, this.state.subTrdRegOrderTypeKey, this.state.selectedFixingCode);
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeSubTrdRegisterCmdty', component:"TradeRegister"});
    }
  }

  changeFlag = () => {
    try{
    	this.setState({showRptDialog: true});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'changeFlag', component:"TradeRegister"});
    }
  }

  generatePdf=(format)=>{
    try{
      const alldealQty_opt=this.state.alldealQty_opt;
      const user = JSON.parse(localStorage.getItem('user'));
      const platform = localStorage.getItem('platform');
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const region = navigator.language;
      let response = '';
      if (this.props.SubTrdRegisterData.length === 0 || this.props.SubTrdRegisterData === '' || this.props.SubTrdRegisterData === null) {
        this.setState({ showRptDialog: true });
      } else if (format === 'PDF') {
        var xhr = new XMLHttpRequest();
        let url = '/user/export_SubTrdReg_pdf?startDate='+moment(this.state.startDate).format('DD-MM-YYYY')+'&endDate='+moment(this.state.endDate).format('DD-MM-YYYY')+
        '&cmdty='+this.state.subTrdRegisterCmdtyKey+'&tradeType='+this.state.tradeTypeKey+'&orderType='+this.state.subTrdRegOrderTypeKey+'&qtyType='+this.state.qty_type+'&timezone='+timezone+'&region='+region
        url = this.state.selectedFixingCode ? url+'&fc_code='+this.state.selectedFixingCode : url
        xhr.open('GET', getPath("api") + url);
        xhr.setRequestHeader('username', this.props.userDetail.UID);
        xhr.setRequestHeader('SID', this.props.userDetail.SID);
        xhr.setRequestHeader('location', user.location);
        xhr.setRequestHeader('Cache-Control','no-cache');
        xhr.setRequestHeader('platform',platform);
        xhr.setRequestHeader('accCode',this.props.DFA.C);
        xhr.responseType = 'blob';
        xhr.onload = function (dispatch) {
        if(xhr.status === 200){
          filesaver.saveAs(xhr.response, fileName + "_" +this.state.startDate + "_to_" + this.state.endDate + ".pdf");
        }else{
          this.changeFlag();
        }
      }.bind(this);
        xhr.send();
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'generatePdf', component:"TradeRegister"});
    }
  }

  generateInvoice=(row)=>{
    try{
      var docNo=row.toString().split('""');
      var getdocType = row.toString().split('/');
      var docType=getdocType[0];
      if(docType !== 'PFC'){
        this.props.getInvoice(docNo,docType);
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'generateInvoice', component:"TradeRegister"});
    }
  }

  onChangeTradeType=(value,key)=>{
    try{
      this.setState({tradeType:value});
      this.setState({tradeTypeKey:key});
      this.setState({ tradeTypeAction: key });
      this.setOrdersDetails();
      const fixingDet = this.props.fixingEvents.length ? this.props.fixingEvents[0] : null
      const cmdtyData = this.getCmdtyData(fixingDet.IID)
      const FC = fixingDet ? fixingDet.FC : ''
      const FN = fixingDet ? fixingDet.FN : ''
      const cmdtId = cmdtyData.length ? cmdtyData[0].cmdtId : '';
      const cmdtDesc = cmdtyData.length ? cmdtyData[0].cmdtDesc : '';
      const orderStatus = 'O'
      if (value == 'orders') {
        this.setState({
          qty_types: false,
          subTrdRegOrderType:'Outstanding',
          actionType : orderStatus,
          subTrdRegOrderTypeKey : orderStatus
        });
      }else if (value == 'fixingOrders') {
        this.setState({
          qty_types: false,
          subTrdRegOrderType:'Outstanding',
          actionType : orderStatus,
          subTrdRegOrderTypeKey : orderStatus,
          selectedFixingCode : FC,
          selectedFixingEvent : FN,
          CmdtyPairdata: cmdtyData,
          subTrdRegisterCmdtyKey: cmdtId,
          subTrdRegisterCmdty: cmdtDesc,
          SubTrdOutstandingCols : fixingOutCols,
          SubTrdFillOrderCols : fixingFillCols,
          SubTrdOrderCols : fixingCancelledCols
        });
      }else {
        this.setState({qty_types: true});
        this.setState({actionType: ''});
        this.setState({subTrdRegOrderType:''});
      }
      this.setState({ loadtableflag: true });
      if (key === 'D') {
        this.props.loadTradeRegReport(moment(this.state.startDate).format('DD-MM-YYYY'),moment(this.state.endDate).format('DD-MM-YYYY'),this.state.subTrdRegisterCmdtyKey,this.state.qty_type, key, this.state.subTrdRegOrderTypeKey);
      } 
      else if (key === 'FO') {
        this.props.loadTradeRegReport(moment(this.state.startDate).format('DD-MM-YYYY'),moment(this.state.endDate).format('DD-MM-YYYY'), cmdtId, '', key, orderStatus, FC);
      }
      else {
        this.props.loadTradeRegReport(moment(this.state.startDate).format('DD-MM-YYYY'),moment(this.state.endDate).format('DD-MM-YYYY'),this.state.subTrdRegisterCmdtyKey, '', key, orderStatus);
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeTradeType', component:"TradeRegister"});
    }
  }

  onChangeSearchValue(value){
    try{
      this.setState({searchValue: value });
      var count=this.state.actionType != 'O' && this.state.tradeTypeAction === 'O' && this.state.actionType != 'F' ?getCountofTableRows(this.props.SubTrdRegisterData,this.state.SubTrdOrderCols,value)
      :this.state.tradeTypeAction === 'D'?getCountofTableRows(this.props.SubTrdRegisterData,this.state.SubTrdDealCols,value)
      :this.state.actionType ==='O'?getCountofTableRows(this.props.SubTrdRegisterData,this.state.SubTrdOutstandingCols,value)
      :getCountofTableRows(this.props.SubTrdRegisterData,this.state.SubTrdFillOrderCols,value);
      this.setState({reportsRowsCount: count });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeSearchValue', component:"TradeRegister"});
    }
  }

  onChangeSubTrdRegColumnOrder(newOrder) {
    try{
      this.setState({ subTrdRegColumnOrder: newOrder });
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeSubTrdRegColumnOrder', component:"TradeRegister"});
    }
  }

  onChangeHiddenSubTrdOrderCol(hiddenCol){
    try{
      this.setState({ HiddenSubTrdOrderCol : hiddenCol});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeHiddenSubTrdOrderCol', component:"TradeRegister"});
    }
  };

  onChangeHiddenSubTrdOutCol(hiddenCol){
    try{
      this.setState({ HiddenSubTrdOutCol : hiddenCol});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeHiddenSubTrdOutCol', component:"TradeRegister"});
    }
  };

  onChangeHiddenSubTrdDealCol(hiddenCol){
    try{
      this.setState({ HiddenSubTrdDealCol : hiddenCol});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeHiddenSubTrdDealCol', component:"TradeRegister"});
    }
  };

  onChangeHiddenSubTrdFillCol(hiddenCol){
    try{
      this.setState({ HiddenSubTrdFillCol : hiddenCol});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onChangeHiddenSubTrdFillCol', component:"TradeRegister"});
    }
  };

  afterOpenModal() {
    try{
      const thisComponent = this.refs.errorMSG;
      //const allCssStyleRules = this.props.selectedCssColorTheme;
      const elementsData = [
        {"classNames":"closeBtn","elementType":"normal", "applyTo":"single", "tagNames":"div"},
        {"classNames":"button-l","elementType":"normal", "applyTo":"single", "tagNames":"button"},
      ];
      //applyStyle(thisComponent, allCssStyleRules, elementsData);
      const directionData = [
        {"classNames":"header", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"commonCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"commonMsgDir", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"button-l","elementType":"normal", "applyTo":"single", "tagNames":"button"},
      ];
      setDirection(thisComponent,directionData,this.props.selectedLang);
      const hoverElementsClassNames = [
        {"elmToHover":thisComponent.getElementsByClassName("closeBtn")[0], "classNames":"closeBtn"},
        {"elmToHover":thisComponent.getElementsByClassName("button-l")[0], "classNames":"button-l"},
      ];
      // //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'afterOpenModal', component:"TradeRegister"});
    }
  }

  fixingSelection = (fixingDet) =>{
    try{
      this.setState({ loadtableflag: true });
      const fixingCode = fixingDet.FC;
      const fixingEvent = fixingDet.FN;
      const cmdtyData = this.getCmdtyData(fixingDet.IID)
      if (fixingDet.IID.length !== 0) {
        this.setState({
          CmdtyPairdata: cmdtyData,
          subTrdRegisterCmdtyKey:cmdtyData[0].cmdtId,
          subTrdRegisterCmdty:cmdtyData[0].cmdtDesc,
          selectedFixingCode:fixingCode,
          selectedFixingEvent :fixingEvent
        });
        this.props.loadTradeRegReport(moment(this.state.startDate).format('DD-MM-YYYY'),moment(this.state.endDate).format('DD-MM-YYYY'),fixingDet.IID[0].ID, '', this.state.tradeTypeKey, this.state.subTrdRegOrderTypeKey, fixingCode);
      } else {
        this.setState({
          CmdtyPairdata: cmdtyData,
          subTrdRegisterCmdtyKey: '',
          subTrdRegisterCmdty: '',
          selectedFixingCode:fixingCode,
          selectedFixingEvent :fixingEvent
        });
        this.props.loadTradeRegReport(moment(this.state.startDate).format('DD-MM-YYYY'),moment(this.state.endDate).format('DD-MM-YYYY'),'', '', this.state.tradeTypeKey, this.state.subTrdRegOrderTypeKey, fixingCode);
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'fixingSelection', component:"TradeRegister"});
    }
  }

  setOrdersDetails = () => {
    const { subTrdRegisterCmdtyKey , subTrdRegisterCmdty } = this.state;
    let obj = {
      cmdtId: 'ALL',
      cmdtDesc: i18next.t('allPairs')
    };
    var dcoObj=this.props.DCO;
    if(dcoObj.findIndex(x => x.cmdtId=="ALL") === -1){
      dcoObj.unshift(obj);
    }
    this.setState({
      CmdtyPairdata: dcoObj,
      subTrdRegisterCmdtyKey: subTrdRegisterCmdtyKey === 'allPairs' ? dcoObj[0].cmdtId : subTrdRegisterCmdtyKey,
      subTrdRegisterCmdty : subTrdRegisterCmdty === 'All Pairs' ? dcoObj[0].cmdtDesc : subTrdRegisterCmdty,
      selectedFixingCode : undefined,
      selectedFixingEvent: '',
      SubTrdOutstandingCols : ordersOutCols,
      SubTrdFillOrderCols : orderFillCols,
      SubTrdOrderCols : orderCols
    });
  }

  getCmdtyData = (IID) => {
    let cmdtyDet = IID
    if(cmdtyDet && cmdtyDet.length){
      cmdtyDet.forEach((d)=>{
        d.cmdtId = d.ID
        d.cmdtDesc = d.DESC
      })
    }
    return cmdtyDet;
  }
  
  // To set Filter out columns dynamically
  filterOrderCols = (columns, type = "col") => {
    const { actionType } = this.state;
    const colsToRemove =    {
      'A': [],
      'C': ['deal_doc_no'],
      'E': ['deal_doc_no'],
    }[actionType] || [];

    if(type === "data"){
      return columns.map((excelData) => excelData.filter(col => !colsToRemove.includes(col.name)));
    }
    return columns.filter(col => !colsToRemove.includes(col.name));
  };

  render() {
    const {subTrdRegisterCmdty,tradeType,tradeTypeKey,actionType,subTrdRegOrderType,qtyTypeSelected,COM}=this.state;
    const limitFixingOrders = tradeType === 'orders' || tradeType === 'fixingOrders'
    const start = this.state.startDate;
    const end = this.state.endDate;
    let label = start+ ' - ' +end;
    if (start === end) {
      label = start;
    }
    const excelOrd = tradeType === 'orders' ? 'Ord' : 'Fix'
    if (this.state.tradeTypeKey == "D") {
      fileName = "Rpt_TrdReg_Deal";
    }
    else {
      if (this.state.subTrdRegOrderTypeKey == "A") {
        fileName = "Rpt_TrdReg_Ord_All";
      }
      else if (this.state.subTrdRegOrderTypeKey == "O") {
        fileName = `Rpt_TrdReg_${excelOrd}_Out`;
      }
      else if (this.state.subTrdRegOrderTypeKey == "F") {
        fileName = `Rpt_TrdReg_${excelOrd}_Fill`;
      }
      else if (this.state.subTrdRegOrderTypeKey == "C") {
        fileName = `Rpt_TrdReg_${excelOrd}_Can`;
      }
      else if (this.state.subTrdRegOrderTypeKey == "E") {
        fileName = "Rpt_TrdReg_Ord_Exp";
      }
    }
    var quantity ='';
    let SubTrdDealCols=[
     {name: 'docno',title:i18next.t('docNo'), width: {wpx: 150}},
     {name: 'docdate',title:i18next.t('docDate'), width: {wpx: 110}},
     {name: 'valdate',title:i18next.t('valueDate'), width: {wpx: 110}},
     {name: 'deal_type',title:i18next.t('deal'), width: {wpx: 80}},
     {name: 'inst_desc',title:i18next.t('cmdtyPair'), width: {wpx: 110}},
     {name: 'grs_qty',title:i18next.t(this.state.qtyTypeColName), width: {wpx: 110}},
     {name: 'mtl_rate',title:i18next.t('price'), width: {wpx: 120}},
     {name: 'amt',title:i18next.t('amount'), width: {wpx: 130}},
     {name: 'evt_ts',title:i18next.t('eventTime'), width: {wpx: 200}},
     {name: 'remarks',title:i18next.t('comments'), width: {wpx: 400}}
    ];
    const orderColsExcel = [
      {name: 'docno',title:i18next.t('orderNo'), width: {wpx: 150}},
      {name: 'docdate',title:i18next.t('docDate'), width: {wpx: 110}},
      {name: 'deal_type',title:i18next.t('deal'), width: {wpx: 80}},
      {name: 'inst_desc',title:i18next.t('cmdtyPair'), width: {wpx: 110}},
      {name: 'pcs_qty',title:i18next.t('quantity'), width: {wpx: 110}},
      {name: 'ord_stk_code',title:i18next.t('qtyType'), width: {wpx: 100}},
      {name: 'price',title:i18next.t('price'), width: {wpx: 150}},
      {name: 'VT',title:i18next.t('validity'), width: {wpx: 80}},
      {name: 'ord_status',title:i18next.t('status'), width: {wpx: 130}},
      {name: 'deal_doc_no',title:i18next.t('docNo'), width: {wpx: 160}},
      {name: 'remarks',title:i18next.t('comments'), width: {wpx: 400}}
    ];
    const ordersOutColsExcel = [
      {name: 'docno',title:i18next.t('orderNo'), width: {wpx: 150}},
      {name: 'docdate',title:i18next.t('docDate'), width: {wpx: 110}},
      {name: 'deal_type',title:i18next.t('deal'), width: {wpx: 80}},
      {name: 'inst_desc',title:i18next.t('cmdtyPair'), width: {wpx: 110}},
      {name: 'pcs_qty',title:i18next.t('quantity'), width: {wpx: 110}},
      {name: 'ord_stk_code',title:i18next.t('qtyType'), width: {wpx: 100}},
      {name: 'price',title:i18next.t('price'), width: {wpx: 150}},
      //{name: 'stp_type',title:i18next.t('Type')},
      {name: 'VT',title:i18next.t('validity'), width: {wpx: 80}},
      {name: 'remarks',title:i18next.t('comments'), width: {wpx: 400}}
    ];
    const orderFillColsExcel = [
      {name: 'docno',title:i18next.t('orderNo'), width: {wpx: 150}},
      {name: 'docdate',title:i18next.t('docDate'), width: {wpx: 110}},
      {name: 'deal_type',title:i18next.t('deal'), width: {wpx: 80}},
      {name: 'inst_desc',title:i18next.t('cmdtyPair'), width: {wpx: 110}},
      {name: 'pcs_qty',title:i18next.t('quantity'), width: {wpx: 110}},
      {name: 'ord_stk_code',title:i18next.t('qtyType'), width: {wpx: 100}},
      {name: 'price',title:i18next.t('price'), width: {wpx: 150}},
      //{name: 'stp_type',title:i18next.t('Type')},
      {name: 'VT',title:i18next.t('validity'), width: {wpx: 80}},
      {name: 'ord_status',title:i18next.t('status'), width: {wpx: 130}},
      {name: 'deal_doc_no',title:i18next.t('docNo'), width: {wpx: 150}},
      {name: 'remarks',title:i18next.t('comments'), width: {wpx: 400}}
    ];
    const fixingOutColsExcel = [
      {name:'docno', title:i18next.t('orderNo'), width:{wpx:150}},
      {name:'docdate', title:i18next.t('fixingDate'), width:{wpx:100}},
      {name:'fixingEvent', title:i18next.t('fixingEvent'), width:{wpx:150}},
      {name:'deal_type', title:i18next.t('deal'), width:{wpx:110}},
      {name:'inst_desc', title:i18next.t('cmdtyPair'), width:{wpx:80}},
      {name:'pcs_qty', title:i18next.t('qty'), align:'right', width:{wpx:110}},
      {name:'ord_stk_code', title: i18next.t('qtyType'), width:{wpx:80}},
      {name:'remarks', title:i18next.t('comments'), width:{wpx:250}},
    ];
    const fixingFillColsExcel = [
      {name:'docno', title:i18next.t('orderNo'), width:{wpx:150}},
      {name:'fixingEvent', title:i18next.t('fixingEvent'), width:{wpx:150}},
      {name:'deal_type', title:i18next.t('deal'), width:{wpx:85}},
      {name:'inst_desc', title:i18next.t('cmdtyPair'), width: {wpx:80}},
      {name:'filledTime', title:i18next.t('filledTime'), width:{wpx:200}},
      {name:'pcs_qty', title: i18next.t('filledQty'), align:'right', width:{wpx:80}},
      {name:'ord_stk_code', title: i18next.t('qtyType'), width:{wpx:80}},
      {name:'price', title:i18next.t('price'), align:'right', width:{wpx:110}},
      {name:'deal_doc_no', title:i18next.t('docNo'), width:{wpx:150}},
      {name:'remarks', title:i18next.t('comments'), width:{wpx:400}}
    ];
    const fixingCancelledColsExcel = [
      {name:'docno', title:i18next.t('orderNo'), width:{wpx:150}},
      {name:'fixingEvent', title:i18next.t('fixingEvent'), width:{wpx:150}},
      {name:'deal_type', title:i18next.t('deal'), width:{wpx:85}},
      {name:'inst_desc', title:i18next.t('cmdtyPair'), width:{wpx:80}},
      {name:'cancelledTime', title:i18next.t('cancelledTime'), width:{wpx:200}},
      {name:'pcs_qty', title: i18next.t('cancelledQty'), align:'right', width:{wpx:100}},
      {name:'ord_stk_code', title: i18next.t('qtyType'), width:{wpx:80}},
      {name:'remarks', title:i18next.t('comments'), width:{wpx:110}},
    ];
   let SubTrdOrderCols = tradeTypeKey === 'FO' ? fixingCancelledColsExcel : this.filterOrderCols(orderColsExcel)
   let SubTrdFillOrderCols = tradeTypeKey === 'FO' ? fixingFillColsExcel : orderFillColsExcel
   let SubTrdOutstandingCols = tradeTypeKey === 'FO' ? fixingOutColsExcel : ordersOutColsExcel
   var tableDataOut = [];
   var tableDataFill = [];
   var tableDataOrd = [];
   var tableDataDeal = [];
   var propData = this.props.SubTrdRegisterData;
   for(let i=0;i<propData.length;i++){
     tableDataOut[i] = tradeTypeKey === 'FO' ?  [{value: propData[i].docno, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].docdate, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].fixingEvent, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].deal_type, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].inst_desc, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].pcs_qty, style: {alignment: {wrapText: true,horizontal:"right"}}} , {value: propData[i].ord_stk_code, style: {alignment: {wrapText: true,horizontal:"left"}}} , {value: propData[i].remarks, style: {alignment: {horizontal:"left"}}}] :
     [{value: propData[i].docno, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].docdate, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].deal_type, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].inst_desc, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].pcs_qty, style: {alignment: {wrapText: true,horizontal:"right"}}} , {value: propData[i].ord_stk_code, style: {alignment: {wrapText: true,horizontal:"left"}}} , {value: propData[i].price, style: {alignment: {wrapText: true,horizontal:"right"}}},{value: propData[i].VT, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].remarks, style: {alignment: {horizontal:"left"}}}];

     tableDataFill[i] = tradeTypeKey === 'FO' ? [{value: propData[i].docno, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].fixingEvent, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].deal_type, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].inst_desc, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].filledTime, style: {alignment: {horizontal:"left"}}}, {value: propData[i].pcs_qty, style: {alignment: {wrapText: true,horizontal:"right"}}} , {value: propData[i].ord_stk_code, style: {alignment: {wrapText: true,horizontal:"left"}}} , {value: propData[i].price, style: {alignment: {wrapText: true,horizontal:"right"}}}, {value: propData[i].deal_doc_no, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].remarks, style: {alignment: {horizontal:"left"}}}] :
     [{value: propData[i].docno, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].docdate, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].deal_type, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].inst_desc, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].pcs_qty, style: {alignment: {wrapText: true,horizontal:"right"}}} , {value: propData[i].ord_stk_code, style: {alignment: {wrapText: true,horizontal:"left"}}} , {value: propData[i].price, style: {alignment: {wrapText: true,horizontal:"right"}}},{value: propData[i].VT, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].ord_status, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].deal_doc_no, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].remarks, style: {alignment: {horizontal:"left"}}} ]

     tableDataOrd[i] = tradeTypeKey === 'FO' ? [{value: propData[i].docno, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].fixingEvent, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].deal_type, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].inst_desc, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].cancelledTime, style: {alignment: {horizontal:"left"}}}, {value: propData[i].pcs_qty, style: {alignment: {wrapText: true,horizontal:"right"}}} , {value: propData[i].ord_stk_code, style: {alignment: {wrapText: true,horizontal:"left"}}} , {value: propData[i].remarks, style: {alignment: {horizontal:"left"}}} ] :
     [{value: propData[i].docno, name:"docno", style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].docdate, name:"docdate", style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].deal_type, name:"deal_type", style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].inst_desc, name:"inst_desc", style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].pcs_qty, name:"pcs_qty", style: {alignment: {wrapText: true,horizontal:"right"}}} , {value: propData[i].ord_stk_code, name:"ord_stk_code", style: {alignment: {wrapText: true,horizontal:"left"}}} , {value: propData[i].price, name:"price", style: {alignment: {wrapText: true,horizontal:"right"}}},{value: propData[i].VT, name:"VT", style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].ord_status, name:"ord_status", style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i]?.deal_doc_no || "", name:"deal_doc_no", style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].remarks, name:"remarks", style: {alignment: {horizontal:"left"}}} ];

     tableDataDeal[i] = [{value: propData[i].docno, style: {alignment: {wrapText: true,horizontal:"left"}}},{value: propData[i].docdate, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].valdate, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].deal_type, style: {alignment: {wrapText: true,horizontal:"left"}}}, {value: propData[i].inst_desc, style: {alignment: {wrapText: true,horizontal:"left"}}} , {value: propData[i].grs_qty, style: {alignment: {wrapText: true,horizontal:"right"}}} , {value: propData[i].mtl_rate, style: {alignment: {wrapText: true,horizontal:"right"}}},{value: propData[i].amt, style: {alignment: {wrapText: true,horizontal:"right"}}},{value: propData[i].evt_ts, style: {alignment: {horizontal:"left"}}},{value: propData[i].remarks, style: {alignment: {horizontal:"left"}}}];
    }

    let multiDataSetOut = [{
       columns: SubTrdOutstandingCols,
       data: tableDataOut
     }];
     let multiDataSetFill = [{
       columns: SubTrdFillOrderCols,
       data: tableDataFill
     }];
     let multiDataSetOrd = [{
       columns: this.filterOrderCols(SubTrdOrderCols),
       data: this.filterOrderCols(tableDataOrd,"data")
     }];
     let multiDataSetDeal = [{
       columns: SubTrdDealCols,
       data: tableDataDeal
     }];

   const pagingPanelMessages = {
      showAll: i18next.t('all'),
      rowsPerPage: i18next.t('rowsPerPage'),
      info:'',
    };

   const searchPlaceholderMsg = {
      searchPlaceholder: i18next.t('search')+'...',
    };

   const PagingContainer = props => (
       <PagingPanel.Container {...props} className="pagingPanelDiv" />
   );

   const PagingContainerdark = props => (
     <PagingPanel.Container {...props} className="pagingPanelDivDark"  />
   );

   const GenerateInvoiceCell = ({ value, style }) => (
     <Table.Cell>
       <span>
       { value.indexOf('PFC') === -1 ? <a className='trdeBookCell' title={i18next.t("invoiceDownldMsg")} onClick={()=>this.generateInvoice(value)}>
           {value}
         </a>
       :value}
       </span>
     </Table.Cell>
   );

   const GenerateInvoiceFillCell = ({ value, style }) => (
     <Table.Cell>
       <span>
       <a className='trdeBookCell' title={i18next.t("invoiceDownldMsg")} onClick={()=>this.generateInvoice(value)}>
           {value}
         </a>
       </span>
     </Table.Cell>
   );

   const TableCell = props => {
     const { column } = props;
     if (column.name === "docno") {
       return <GenerateInvoiceCell {...props} />;
     }
     return <Table.Cell {...props} />;
   };

   const TableFillCell = props => {
     const { column } = props;
     if (column.name === "deal_doc_no") {
       return <GenerateInvoiceFillCell {...props} />;
     }
     return <Table.Cell {...props} />;
   };

   var NoDataMsg = {
     noData: '',
   }
  if (this.state.loadtableflag === true) {
    NoDataMsg.noData = '';
  }
  else {
    NoDataMsg.noData = i18next.t("noDataAvlMsg");
  }

  const NoDataCell = props => (
    <Table.NoDataCell {...props} className="noDataCell" />
  );

  const rowStyle = theme => ({
    tableStriped: {
      '& tbody tr:nth-of-type(odd)': {
        // backgroundColor: this.props.selectedCssColorTheme.listRow.background,
        // color:this.props.selectedCssColorTheme.listRow.color
      },
      '& tbody tr:nth-of-type(even)': {
        // backgroundColor: this.props.selectedCssColorTheme.rptListRowNext.background,
        // color:this.props.selectedCssColorTheme.listRow.color
      },
      '& thead th': {
        //backgroundColor: this.props.selectedCssColorTheme.rptListRowNext.background,
        //color:this.props.selectedCssColorTheme.tableHeaderColor.color
      },
      '& .text-primary': {
        //color: this.props.selectedCssColorTheme.activeHeaderColor.color
      },
    },
  });

  const TableComponentBase = ({ classes, ...restProps }) => (
    <Table.Table {...restProps} id="trdRegTable" className={classes.tableStriped}/>
  );

  const dropDownListColor =theme =>({
    dropDownListHoverMenu:{
      '& .dropdown-item':{
          // background:this.props.selectedCssColorTheme.dropDownList.background,
          // color:this.props.selectedCssColorTheme.dropDownList.color
        },
        '& :hover':{
          // background:this.props.selectedCssColorTheme.dropDownListHover.background,
          // color:this.props.selectedCssColorTheme.dropDownListHover.color
        }
    }
  });

  const ContainerColor = ({ classes, ...restProps }) => (
    <ColumnChooser.Container {...restProps} className={classes.dropDownListHoverMenu}  />
  );

  const MenuColor = props => (
    <ColumnChooser.Item {...props} />
  );

  return (
    <div id="trdRegMainDiv" className={`${this.props.language}`}>
      <Modal isOpen={this.state.validationFlag} id="trdRegDateValModal" className={styles.warningModal} onAfterOpen={this.afterOpenModal}>
        <div ref="errorMSG" className="mdlWrap" style={this.props.selectedCssColorTheme.mdlWrap}>
          <div className={`${styles.header} header`} style={this.props.selectedCssColorTheme.rptModalHeader}>Error
            <span onClick={this.closeValidationModal} className={`${styles.closeImg} closeIcon`} >{this.props.closeIcon}</span>
          </div>
          <div className={`${styles.msg} commonMsgDir`} >
            <h4>{i18next.t("dateSelectorErrMsg")}</h4>
          </div>
        </div>
      </Modal>
  		<Modal isOpen={this.state.showRptDialog} className={styles.warningModal} id="idlRptModal" onAfterOpen={this.afterOpenModal}>
  			<div ref="errorMSG" className="mdlWrap" >
  				<div className={`${styles.header} header`} >
  					<span className={`${styles.msgTitle}`}>{i18next.t("trdRegister")}</span>
            <span onClick={this.closeRptModal} className={`${styles.closeImg} closeIcon`} id="idlRptCloseIcon">{this.props.closeIcon}</span>
  				</div>
  				<div className={`${styles.msg} commonMsgDir`} style={this.props.selectedCssColorTheme.rptModalMsg}>
  					{i18next.t("noDataAvlMsg")}
  				</div>
  				<div className={`${styles.btnWrap} col-md-12`}>
  					<Button className='button-l' bsStyle="primary" onClick={this.closeRptModal} id="idlRptCloseBtn" >{i18next.t("OK")}</Button>
  				</div>
  			</div>
  		</Modal>
  		<div className={`${styles.subTrdfilterBar} subTrdTbl ${this.props.selectedCssColor}`} id="subTrdtable">
  			<div className={`${styles.subTrdfilterBarInner} fltrBarInner`} >
  				<div className={styles.selectDatebtn} id="trdregrptDate">
                    <DateSelector
                        disabled={this.state.subTrdRegOrderType.toLowerCase() === 'outstanding'}
                        keyValue={this.state.keyValue}
                        onClickFilter={this.getSubTrdReg}
                        setStartDate={this.setStartDate}
                        setEndDate={this.setEndDate}
                        component='Report'
                    />
  				</div>
          {this.state.tradeTypeKey === 'FO' ?
            <div className={`${styles.subTrdfiltertrdType} subTrdDrpdown width12`}>
              <DropdownButton id="fixingEvent" className="form-control trdDropDown btnText" title={this.state.selectedFixingEvent} >
                {this.props.fixingEvents.map((item, index) => {
                  return (
                    <MenuItem eventKey={item.FC} onClick={() => this.fixingSelection(item)}>{item.FN}</MenuItem>
                  );
                })}
              </DropdownButton>
            </div> : null}
  				<DcoDropdown
  					parentDivClassname={`${styles.subTrdfilterItem} subTrdDrpdown`}
  					parentDivId="ScrollCss"
  					dropdownTitle={i18next.t(subTrdRegisterCmdty)}
  					dropdownId="bg-nested-dropdown"
  					dropdownData={this.state.CmdtyPairdata}
  					dataItemClick={this.onChangeSubTrdRegisterCmdty}
            dropdownClassname="btnText"
  				/>
          {this.state.qty_types === true ?
            <div className={`${styles.subTrdfiltertrdType} subTrdDrpdown`}>
            <DropdownButton title={i18next.t(qtyTypeSelected)} id="dropdown-size-medium" className={`${styles.PoskeepingAcc} reportsDropdown btnText`} disabled={COM === 1} >
              <MenuItem onClick={() => this.changeQty_type('OZ', 'OZ')} id="trdMeasureMkt" >OZ</MenuItem>
              <MenuItem onClick={() => this.changeQty_type('GMS', 'GMS')} id="trdMeasureMkt" >GMS</MenuItem>
            </DropdownButton>
          </div> : null}
          <div className={`${styles.subTrdfiltertrdType} subTrdDrpdown`}>
  					<DropdownButton  title={i18next.t(this.state.tradeType)} id="bg-nested-dropdown" className="reportsDropdown btnText"  >
              <MenuItem onClick={() => this.onChangeTradeType("trades","D")} id="suubTradeDeals">{i18next.t("trades")}</MenuItem>
  						<MenuItem onClick={() => this.onChangeTradeType("orders","O")} id="subTradeOrders">{i18next.t("orders")}</MenuItem>
              {this.props.userDetail.enableFXOrd ? <MenuItem onClick={() => this.onChangeTradeType("fixingOrders","FO")} id="subTradeOrders">{i18next.t("fixingOrders")}</MenuItem> : null}
  					</DropdownButton>
  				</div>
          {limitFixingOrders ?
          <div className={`${styles.subTrdfiltertrdType} subTrdDrpdown`}>
            <DropdownButton title={i18next.t(subTrdRegOrderType)} id="bg-nested-dropdown" className="reportsDropdown btnText"  >
              {tradeType === "orders" && <MenuItem onClick={() => this.subTrdRegOrderType("all", "A")} id="subTrdAll" >{i18next.t("all")}</MenuItem>}
              <MenuItem onClick={() => this.subTrdRegOrderType("outstanding", "O")} id="subTrdOtstng" >{i18next.t("outstanding")}</MenuItem>
              <MenuItem onClick={() => this.subTrdRegOrderType("filled", "F")} id="subTrdFilled" >{i18next.t("filled")}</MenuItem>
              <MenuItem onClick={() => this.subTrdRegOrderType("cancelled", "C")} id="subTrdCancelled" >{i18next.t("cancelled")}</MenuItem>
              {tradeType === "orders" && <MenuItem onClick={() => this.subTrdRegOrderType("expired", "E")} id="subTrdExpired" >{i18next.t("expired")}</MenuItem>}
            </DropdownButton>
  				</div>
          : null}
  				<div className={`${styles.exportfileBaracc} allExportFilter`}>
  					<div className="commonGoBtn" id="subTrdgobtn">
  						<button type="button" className={this.state.isRefreshDisabled === true ? `${styles.disabled} ${styles.goBtn}` : `${styles.goBtn}` } onClick={this.getSubTrdReg} id="idlRptRefresh">
                {this.props.refreshIcon}
  						</button>
  					</div>
  					<label className={this.state.loadtableflag === true ? "disableLabel" : null}>
            {(this.props.SubTrdRegisterData.length!==0) && <span><ExcelFile  filename={fileName} element={(<img src="/images/xls.png"/>)}>
                {
                 this.state.actionType != 'O' && limitFixingOrders && this.state.actionType != 'F' ? <ExcelSheet dataSet={multiDataSetOrd} name="TradeRegister" />
                 :
                 tradeTypeKey === 'D' ? <ExcelSheet dataSet={multiDataSetDeal} name="TradeRegister" />
                 :
                 this.state.actionType ==='O' ? <ExcelSheet dataSet={multiDataSetOut} name="TradeRegister" />
                 :
                 limitFixingOrders && this.state.actionType == 'F' ? <ExcelSheet dataSet={multiDataSetFill} name="TradeRegister" />
                 :null}
            </ExcelFile>
                </span>}
              {(this.props.SubTrdRegisterData.length===0) && <img src="/images/xls.png" onClick={this.changeFlag}/>}
  						<span><img src="/images/pdf.png" onClick={()=>{this.generatePdf("PDF")}} id="idlRptGenPDF"/></span>
  					</label>
  				</div>
  			</div>
  		</div>
  		<div className={`${styles.subTrdtbl} subTrdTbl`} id="subTrdtbl">
  			{this.state.loadtableflag === true ?
  				<div className={styles.rptoverlay} >
  					<i className="fa fa-spinner fa-spin spin-big"></i>
  				</div>
  			:null }
          {limitFixingOrders && this.state.actionType != 'O'  && this.state.actionType != 'F' ?
          <div className={`${styles.subTrdOrdertbl} reportsTblGrid`} >
            <Grid rows={this.props.SubTrdRegisterData} columns={SubTrdOrderCols}>
    					{/* <DragDropProvider /> */}
    					<SortingState defaultSorting={[{ columnName: 'evt_ts', direction: 'desc' }]}/>
    					<IntegratedSorting columnExtensions={this.state.integratedSortingColumnExtensions}/>
    					{this.state.reportsRowsCount>10?<PagingState defaultCurrentPage={0}  defaultPageSize={10}  />
              :null}
    					{this.state.reportsRowsCount>10?<IntegratedPaging />
              :null}
    					<SearchState value={this.state.searchValue} onValueChange={this.onChangeSearchValue}/>
    					<IntegratedFiltering />
    					<Table tableComponent={withStyles(rowStyle, { name: 'TableComponent' }) (TableComponentBase)} columnAutoWidth={true} columnExtensions={this.state.integratedSortingColumnExtensions} cellComponent={TableFillCell}  messages={NoDataMsg} noDataCellComponent={NoDataCell}/>
    					{/* <TableColumnReordering order={this.state.subTrdRegColumnOrder} onOrderChange={this.onChangeSubTrdRegColumnOrder} id="lmtChngOutLmtColOrd"/> */}
    					<TableHeaderRow showSortingControls />
    					<TableColumnVisibility hiddenColumnNames={this.state.HiddenSubTrdOrderCol} onHiddenColumnNamesChange={this.onChangeHiddenSubTrdOrderCol}/>
              {this.state.reportsRowsCount>10 && this.props.selectedCssColor !== "DR" ?<PagingPanel pageSizes={this.state.pageSizes} messages={pagingPanelMessages} containerComponent={PagingContainer}/>
              :
              this.state.reportsRowsCount>10 && this.props.selectedCssColor === "DR" ?
              <PagingPanel pageSizes={this.state.pageSizes} messages={pagingPanelMessages} containerComponent={PagingContainerdark}/>
              :null}
    					<Toolbar />
    					<SearchPanel messages={searchPlaceholderMsg} autoComplete="new-password"/>
    				 <ColumnChooser  containerComponent={withStyles(dropDownListColor, { name: 'ContainerComponent' })(ContainerColor)} itemComponent={MenuColor} />
    				</Grid>
          </div>:null}
          {tradeTypeKey === 'D'?
          <div className={`${styles.subTrdDealtbl} reportsTblGrid`} >
            <Grid rows={this.props.SubTrdRegisterData} columns={SubTrdDealCols}>
    					{/* <DragDropProvider /> */}
    					<SortingState defaultSorting={[{ columnName: 'evt_ts', direction: 'desc' }]}/>
    					<IntegratedSorting columnExtensions={this.state.integratedSortingColumnExtensions}/>
    					{this.state.reportsRowsCount>10?<PagingState defaultCurrentPage={0}  defaultPageSize={10}  />
              :null}
    					{this.state.reportsRowsCount>10?<IntegratedPaging />
              :null}
    					<SearchState value={this.state.searchValue} onValueChange={this.onChangeSearchValue}/>
    					<IntegratedFiltering />
    					<Table  tableComponent={withStyles(rowStyle, { name: 'TableComponent' }) (TableComponentBase)} columnAutoWidth={true} cellComponent={TableCell} columnExtensions={this.state.integratedSortingColumnExtensions} messages={NoDataMsg} noDataCellComponent={NoDataCell}/>
    					{/* <TableColumnReordering order={this.state.subTrdRegColumnOrder} onOrderChange={this.onChangeSubTrdRegColumnOrder} id="lmtChngOutLmtColOrd"/> */}
    					<TableHeaderRow showSortingControls />
    					<TableColumnVisibility hiddenColumnNames={this.state.HiddenSubTrdDealCol} onHiddenColumnNamesChange={this.onChangeHiddenSubTrdDealCol}/>
              {this.state.reportsRowsCount>10 && this.props.selectedCssColor !== "DR" ?<PagingPanel pageSizes={this.state.pageSizes} messages={pagingPanelMessages} containerComponent={PagingContainer}/>
              :
              this.state.reportsRowsCount>10 && this.props.selectedCssColor === "DR" ?
              <PagingPanel pageSizes={this.state.pageSizes} messages={pagingPanelMessages} containerComponent={PagingContainerdark}/>
              :null}
    					<Toolbar />
    					<SearchPanel messages={searchPlaceholderMsg} autoComplete="new-password"/>
    					<ColumnChooser  containerComponent={withStyles(dropDownListColor, { name: 'ContainerComponent' })(ContainerColor)} itemComponent={MenuColor} />
    				</Grid>
          </div>:null}
          {this.state.actionType ==='O'?
    			<div className={styles.subTrdtblTile} >
            <Grid rows={this.props.SubTrdRegisterData}  columns={SubTrdOutstandingCols}>
    					{/* <DragDropProvider /> */}
    					<SortingState defaultSorting={[{ columnName: 'evt_ts', direction: 'desc' }]}/>
    					<IntegratedSorting columnExtensions={this.state.integratedSortingColumnExtensions}/>
    					{this.state.reportsRowsCount>10?<PagingState defaultCurrentPage={0}  defaultPageSize={10}  />
              :null}
    					{this.state.reportsRowsCount>10?<IntegratedPaging />
              :null}
    					<SearchState value={this.state.searchValue} onValueChange={this.onChangeSearchValue}/>
    					<IntegratedFiltering />
    					<Table tableComponent={withStyles(rowStyle, { name: 'TableComponent' }) (TableComponentBase)} columnAutoWidth={true} columnExtensions={this.state.integratedSortingColumnExtensions} messages={NoDataMsg} noDataCellComponent={NoDataCell}/>
    					{/* <TableColumnReordering order={this.state.subTrdRegColumnOrder} onOrderChange={this.onChangeSubTrdRegColumnOrder} id="lmtChngOutLmtColOrd"/> */}
    					<TableHeaderRow showSortingControls />
    					<TableColumnVisibility hiddenColumnNames={this.state.HiddenSubTrdOutCol} onHiddenColumnNamesChange={this.onChangeHiddenSubTrdOutCol}/>
              {this.state.reportsRowsCount>10 && this.props.selectedCssColor !== "DR" ?<PagingPanel pageSizes={this.state.pageSizes} messages={pagingPanelMessages} containerComponent={PagingContainer}/>
              :
              this.state.reportsRowsCount>10 && this.props.selectedCssColor === "DR" ?
              <PagingPanel pageSizes={this.state.pageSizes} messages={pagingPanelMessages} containerComponent={PagingContainerdark}/>
              :null}
    					<Toolbar />
    					<SearchPanel messages={searchPlaceholderMsg} autoComplete="new-password"/>
    					<ColumnChooser  containerComponent={withStyles(dropDownListColor, { name: 'ContainerComponent' })(ContainerColor)} itemComponent={MenuColor} />
    				</Grid>
          </div>:null}
          {limitFixingOrders && this.state.actionType == 'F'?
          <div className={styles.subTrdFilltbl} >
            <Grid rows={this.props.SubTrdRegisterData}  columns={SubTrdFillOrderCols}>
    					{/* <DragDropProvider /> */}
    					<SortingState defaultSorting={[{ columnName: 'evt_ts', direction: 'desc' }]}/>
    					<IntegratedSorting columnExtensions={this.state.integratedSortingColumnExtensions}/>
    					{this.state.reportsRowsCount>10?<PagingState defaultCurrentPage={0}  defaultPageSize={10}  />
              :null}
    					{this.state.reportsRowsCount>10?<IntegratedPaging />
              :null}
    					<SearchState value={this.state.searchValue} onValueChange={this.onChangeSearchValue}/>
    					<IntegratedFiltering />
    					<Table tableComponent={withStyles(rowStyle, { name: 'TableComponent' }) (TableComponentBase)} columnAutoWidth={true} cellComponent={TableFillCell} columnExtensions={this.state.integratedSortingColumnExtensions} messages={NoDataMsg} noDataCellComponent={NoDataCell}/>
    					{/* <TableColumnReordering order={this.state.subTrdRegColumnOrder} onOrderChange={this.onChangeSubTrdRegColumnOrder} id="lmtChngOutLmtColOrd"/> */}
    					<TableHeaderRow showSortingControls />
    					<TableColumnVisibility hiddenColumnNames={this.state.HiddenSubTrdFillCol} onHiddenColumnNamesChange={this.onChangeHiddenSubTrdFillCol}/>
              {this.state.reportsRowsCount>10 && this.props.selectedCssColor !== "DR" ?<PagingPanel pageSizes={this.state.pageSizes} messages={pagingPanelMessages} containerComponent={PagingContainer}/>
              :
              this.state.reportsRowsCount>10 && this.props.selectedCssColor === "DR" ?
              <PagingPanel pageSizes={this.state.pageSizes} messages={pagingPanelMessages} containerComponent={PagingContainerdark}/>
              :null}
    					<Toolbar />
    					<SearchPanel messages={searchPlaceholderMsg} autoComplete="new-password"/>
    				  <ColumnChooser  containerComponent={withStyles(dropDownListColor, { name: 'ContainerComponent' })(ContainerColor)} itemComponent={MenuColor} />
    				</Grid>
          </div>:null}
  		</div>
    </div>
    );
  }
}
